import { get, put } from 'helpers/api';
import taskApi from 'components/tasks/api';
import debounceActionCreators from 'helpers/redux/debounce_action_creators';

import { retrieveRecords } from './search';
import {
  hideLeadModal,
  showLeadModalAlert,
  hideTaskModal,
  setTaskModalErrors,
  toggleAlert
} from './ui';

export const APPROVE_LEAD_VAULT_ACCESS = 'approve_lead_vault_access';
export const REVOKE_LEAD_VAULT_ACCESS = 'revoke_lead_vault_access';
export const BLOCK_LEAD_VAULT_ACCESS = 'block_lead_vault_access';
export const UNBLOCK_LEAD_VAULT_ACCESS = 'unblock_lead_vault_access';

const debouncedActionCreators = debounceActionCreators({ toggleAlert }, 5000);

export function updateLead(projectId, lead) {
  const { id, ...leadData } = lead;

  const request = put(`/projects/${projectId}/leads/${id}`, { lead: leadData });

  return (dispatch) => {
    request.then(() => {
      dispatch(retrieveRecords());
      dispatch(hideLeadModal());
    }).catch((errors) => {
      if (errors) dispatch(showLeadModalAlert(errors[0]));
    });
  };
}

export function fetchProjectListings(leadId) {
  return get(`leads/${leadId}/project_listings`);
}

export function addTask(taskData) {
  return (dispatch) => {
    taskApi.addTask(taskData).then(() => {
      dispatch(hideTaskModal());
      dispatch(toggleAlert('Task successfully created.', false));
      dispatch(delayedHideAlert());
    }).catch((errors) => {
      dispatch(setTaskModalErrors(errors));
    });
  };
}

function delayedHideAlert() {
  return dispatch => debouncedActionCreators.toggleAlert(dispatch, '', false);
}
